import { partner } from './referral'

const errorMessage = (status, statusText) => {
  console.log('Referral | Update cart attributes error', status, statusText)
}

export const updateCartAttributes = (traffic) => {
  const xhr = new XMLHttpRequest()

  xhr.onload = () => {
    if (xhr.status !== 200) {
      errorMessage(xhr.status, xhr.statusText)
    } else {
      if (partner.isPartner(window.location.href)) {
        partner.notify(window.location.href)
      }
    }
  }
  xhr.onerror = () => {
    errorMessage(xhr.status, xhr.statusText)
  }

  xhr.open('POST', '/cart/update.js')
  xhr.setRequestHeader('Content-Type', 'application/json')
  xhr.send(JSON.stringify({
    attributes: {
      traffic
    }
  }))
}